import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Footer from "../components/footer";
import Header from "../components/header";
import { useNavigate } from "react-router-dom";
import { invoicePDF } from "../../utility/invoice";

const MyOrders = () => {

    // CSS for tooltip
    const tooltipStyle = {
        position: "absolute",
        zIndex: "9999",
        backgroundColor: "white",
        border: "1px solid #ccc",
        padding: "8px",
        borderRadius: "4px",
        whiteSpace: "pre-wrap",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    };

    const navigate = useNavigate();
    const [dataOrderList, setDataOrderList] = useState([]);

    const userInfo = JSON.parse(localStorage.getItem('user-info'));

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData(`https://igapi.heuristticminds.com/api/OrderList/Get-GetOrderListByUserID?user_id=${userInfo.buyer_id}`, setDataOrderList);

    }, [dataOrderList]);

    const columns = [
        {
            name: "Order No",
            selector: row => row.id,
            width: "80px"
        },
        {
            name: "Order Placed",
            selector: (row) => new Date(row.createdOn).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            width: "110px"
        },
        {
            name: "Total Amount",
            selector: (row) => row.amount,
            width: "150px"
        },
        {
            name: "Payment Mode",
            selector: (row) => row.paymentMode,
            width: "150px"
        },
        {
            name: "Placed By",
            cell: (row) => (
                <div className="thvr">
                    <span style={{ cursor: "pointer", textDecoration: "underline" }}>
                        {row.billBuyerName} <i className="bi bi-chevron-down"></i>
                    </span>
                    <div className="twrap">
                        <strong>Company:</strong>
                        <p>{row.billAddress}</p>
                        <strong>Contact:</strong>
                        <p>{row.billBuyerName}</p>
                    </div>
                </div>
            ),
            width: "200px",
        },
        {
            name: "Ship T0",
            cell: (row) => (
                <div className="thvr">
                    <span
                        style={{ cursor: "pointer", textDecoration: "underline" }}>
                        {row.shipBuyerName} <i className="bi bi-chevron-down"></i>
                    </span>
                    <div className="twrap">
                        <strong>Full Address:</strong>
                        <p>{row.shipAddress}</p>

                    </div>
                </div>
            ),
            width: "200px",
        },
        /* {
            name: "Payment Status",
            selector: (row) => row.paymentStatus,
            width: "120px"
        },
        {
            name: "Order Status",
            selector: (row) => row.orderStatus,
            width: "110px"
        }, */
        {
            name: "Action",
            cell: (row) => <>

                <button style={{ width: "130px" }} className={`btn m-1 btn-primary tp`} onClick={(event) => OnViewClick(event, row.id)}><span className="tptitle">View Order Details</span><i className="bi bi-eye-fill"></i>&nbsp;<small>View Details</small></button>
                <button style={{ width: "130px" }} className={`btn m-1 btn-primary tp`} onClick={(event) => OnInvoiceClick(event, row.id)}><span className="tptitle">Download Invoice</span><i className="bi bi-eye-fill"></i>&nbsp;<small>Invoice</small></button>
            </>
        },
    ];

    const OnViewClick = async (event, id) => {
        event.preventDefault(); // Prevents the default behavior of the link

        // Determine the path based on the userType_id
        const path = `/myOrderDetails/${id}`;
        // Navigate to the determined path
        navigate(path);
    };

    const OnInvoiceClick = async (event, id) => {
        event.preventDefault(); // Prevents the default behavior of the link
        invoicePDF(id);
    };


    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3>MY Orders</h3>
                            <div className="p-3 mb-4 shadow">
                                <DataTable
                                    columns={columns}
                                    data={dataOrderList}
                                    pagination
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default MyOrders;